import { render, staticRenderFns } from "./mokuai27.vue?vue&type=template&id=2bc15603&"
import script from "./mokuai27.vue?vue&type=script&lang=js&"
export * from "./mokuai27.vue?vue&type=script&lang=js&"
import style0 from "./mokuai27.vue?vue&type=style&index=0&id=2bc15603&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports